<template>
  <el-dropdown trigger="click" class="d-flex">
    <dara-avatar
      size="md"
      :source="userAvatar"
      class="cursor--pointer mx--md" />
    <el-dropdown-menu slot="dropdown">
      <dara-user-link :id="user.id">
        <el-dropdown-item disabled class="mt-2 mb-3">
          <dara-header size="sm" class="profile">
            {{ user.name }}
          </dara-header>
          <dara-small>
            {{ permission }}
          </dara-small>
        </el-dropdown-item>
      </dara-user-link>
      <el-dropdown-item v-if="user.permission > USERS_ROLES.READER" divided>
        <router-link :to="ARTICLES_URL.create.path">
          <dara-icon size="sm" icon="file-earmark-plus" />
          {{ $t('new-article') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item v-if="user.permission > USERS_ROLES.READER">
        <router-link :to="TRACKS_URL.create.path">
          <dara-icon size="sm" icon="journal-plus" />
          {{ $t('add-track') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item :divided="user.permission === USERS_ROLES.READER">
        <router-link :to="QUESTIONS_URL.create.path">
          <dara-icon size="sm" icon="chat-dots" />
          {{ $t('add-question') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item divided>
        <router-link :to="MY_SPACE_URL.articles.path">
          <dara-icon size="sm" icon="book" />
          {{ $t('articles') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item>
        <router-link :to="MY_SPACE_URL.users.path">
          <dara-icon size="sm" icon="people" />
          {{ $t('users') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item>
        <router-link :to="MY_SPACE_URL.tracks.path">
          <dara-icon size="sm" icon="journals" />
          {{ $t('tracks') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item>
        <router-link :to="MY_SPACE_URL.questions.path">
          <dara-icon size="sm" icon="chat-text" />
          {{ $t('questions') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item>
        <router-link :to="MY_SPACE_URL.departments.path">
          <dara-icon size="sm" icon="folder" />
          {{ $t('departments') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item divided>
        <router-link :to="MY_SPACE_URL.ranking.path">
          <dara-icon size="sm" icon="trophy" />
          {{ $t('ranking') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item v-if="user.permission >= USERS_ROLES.ADMIN">
        <router-link :to="COMPANY_URL.analytics.path">
          <dara-icon size="sm" icon="bar-chart" />
          {{ $t('analytics') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item v-if="user.permission === USERS_ROLES.CEO" divided>
        <router-link :to="COMPANY_URL.edit.path">
          <dara-icon size="sm" icon="building" />
          {{ $t('company') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item :divided="user.permission !== USERS_ROLES.CEO">
        <router-link :to="SETTINGS_URL.default.path">
          <dara-icon size="sm" icon="sliders" />
          {{ $t('settings') }}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item divided>
        <div @click="onLogout">
          <dara-icon size="sm" icon="box-arrow-right" />
          {{ $t('logout') }}
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { HOME_URL } from '@/modules/home/home.constants';
import { MY_SPACE_URL } from '@/modules/my-space/my-space.constants';
import { ARTICLES_URL } from '@/modules/article/article.constants';
import { SETTINGS_URL } from '@/modules/setting/setting.constants';
import { COMPANY_URL } from '@/modules/company/company.constants';
import { QUESTIONS_URL } from '@/modules/question/question.constants';
import { TRACKS_URL } from '@/modules/track/track.constants';
import { removeCookie } from '@/helpers/cookies/cookie';
import { goToLoginPage } from '@/router/route.service';
import { getters } from '@/modules/user/user.store';
import { USERS_ROLES } from '@/modules/user/user.constants';
import { translate } from '@/services/translate.service';

import DaraUserLink from '@/modules/user/components/UserLink.vue';

export default {
  name: 'DaraTopbarUserDropdown',
  components: {
    DaraUserLink,
  },
  data() {
    return {
      user: getters.getUser(),
      HOME_URL,
      MY_SPACE_URL,
      ARTICLES_URL,
      SETTINGS_URL,
      COMPANY_URL,
      USERS_ROLES,
      QUESTIONS_URL,
      TRACKS_URL,
    };
  },
  computed: {
    userAvatar() {
      return this.user.profile_pic;
    },
    permission() {
      return `${translate(USERS_ROLES[this.user.permission])}`;
    },
  },
  methods: {
    removeCookie,
    onLogout() {
      removeCookie('session_id');
      goToLoginPage();
    },
  },
};
</script>

<style scoped>
  .el-dropdown-menu__item {
    color: #606266!important;
    line-height: 20px!important;
  }
</style>
